import LimeProductType from "../../controllers/LimeProductType";

export enum FieldStatus {
    Required,
    // Required (must be filled in) but a value of 0 is accepted. Used for a
    // Dolomite's Ca%, which the Excel tolerates as 0 on the amendment calc.
    RequiredAllowZero,
    Optional,
    Hidden,
}
interface FieldConfig {
    caPercent: FieldStatus;
    caCO3Percent: FieldStatus;
    caOPercent: FieldStatus;
    caSO4Percent: FieldStatus;
    mgPercent: FieldStatus;
    mgCO3Percent: FieldStatus;
    mgOPercent: FieldStatus;
    ccePercent: FieldStatus;
    sPercent: FieldStatus;
    pPercent: FieldStatus;
    kPercent: FieldStatus;
    ph: FieldStatus;
    caMgRatio: FieldStatus;
    fineness: FieldStatus;
}

export const getFieldConfig = (type: LimeProductType): FieldConfig => {
    switch (type) {
        case LimeProductType.Calcite:
            return {
                caPercent: FieldStatus.Required,
                caCO3Percent: FieldStatus.Optional,
                caOPercent: FieldStatus.Optional,
                caSO4Percent: FieldStatus.Hidden,
                mgPercent: FieldStatus.Required,
                mgCO3Percent: FieldStatus.Optional,
                mgOPercent: FieldStatus.Optional,
                ccePercent: FieldStatus.Required,
                sPercent: FieldStatus.Hidden,
                pPercent: FieldStatus.Hidden,
                kPercent: FieldStatus.Hidden,
                ph: FieldStatus.Optional,
                caMgRatio: FieldStatus.Optional,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Dolomite:
            return {
                caPercent: FieldStatus.RequiredAllowZero,
                caCO3Percent: FieldStatus.Hidden,
                caOPercent: FieldStatus.Hidden,
                caSO4Percent: FieldStatus.Hidden,
                mgPercent: FieldStatus.Required,
                mgCO3Percent: FieldStatus.Optional,
                mgOPercent: FieldStatus.Optional,
                ccePercent: FieldStatus.Required,
                sPercent: FieldStatus.Hidden,
                pPercent: FieldStatus.Hidden,
                kPercent: FieldStatus.Hidden,
                ph: FieldStatus.Optional,
                caMgRatio: FieldStatus.Optional,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Gypsum:
            return {
                caPercent: FieldStatus.Required,
                caCO3Percent: FieldStatus.Hidden,
                caOPercent: FieldStatus.Hidden,
                caSO4Percent: FieldStatus.Required,
                mgPercent: FieldStatus.Hidden,
                mgCO3Percent: FieldStatus.Hidden,
                mgOPercent: FieldStatus.Hidden,
                ccePercent: FieldStatus.Hidden,
                sPercent: FieldStatus.Required,
                pPercent: FieldStatus.Hidden,
                kPercent: FieldStatus.Hidden,
                ph: FieldStatus.Hidden,
                caMgRatio: FieldStatus.Hidden,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Magnesium:
            return {
                caPercent: FieldStatus.Hidden,
                caCO3Percent: FieldStatus.Hidden,
                caOPercent: FieldStatus.Hidden,
                caSO4Percent: FieldStatus.Hidden,
                mgPercent: FieldStatus.Required,
                mgCO3Percent: FieldStatus.Optional,
                mgOPercent: FieldStatus.Optional,
                ccePercent: FieldStatus.Optional,
                sPercent: FieldStatus.Hidden,
                pPercent: FieldStatus.Hidden,
                kPercent: FieldStatus.Hidden,
                ph: FieldStatus.Optional,
                caMgRatio: FieldStatus.Hidden,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Potassium:
            return {
                caPercent: FieldStatus.Hidden,
                caCO3Percent: FieldStatus.Hidden,
                caOPercent: FieldStatus.Hidden,
                caSO4Percent: FieldStatus.Hidden,
                mgPercent: FieldStatus.Hidden,
                mgCO3Percent: FieldStatus.Hidden,
                mgOPercent: FieldStatus.Hidden,
                ccePercent: FieldStatus.Hidden,
                sPercent: FieldStatus.Hidden,
                pPercent: FieldStatus.Hidden,
                kPercent: FieldStatus.Required,
                ph: FieldStatus.Hidden,
                caMgRatio: FieldStatus.Hidden,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Phosphate:
            return {
                caPercent: FieldStatus.Hidden,
                caCO3Percent: FieldStatus.Hidden,
                caOPercent: FieldStatus.Hidden,
                caSO4Percent: FieldStatus.Hidden,
                mgPercent: FieldStatus.Hidden,
                mgCO3Percent: FieldStatus.Hidden,
                mgOPercent: FieldStatus.Hidden,
                ccePercent: FieldStatus.Hidden,
                sPercent: FieldStatus.Hidden,
                pPercent: FieldStatus.Required,
                kPercent: FieldStatus.Hidden,
                ph: FieldStatus.Hidden,
                caMgRatio: FieldStatus.Hidden,
                fineness: FieldStatus.Optional,
            }
        case LimeProductType.Mix:
        case LimeProductType.Other:
        default:
            return {
                caPercent: FieldStatus.Optional,
                caCO3Percent: FieldStatus.Optional,
                caOPercent: FieldStatus.Optional,
                caSO4Percent: FieldStatus.Optional,
                mgPercent: FieldStatus.Optional,
                mgCO3Percent: FieldStatus.Optional,
                mgOPercent: FieldStatus.Optional,
                ccePercent: FieldStatus.Optional,
                sPercent: FieldStatus.Optional,
                pPercent: FieldStatus.Optional,
                kPercent: FieldStatus.Optional,
                ph: FieldStatus.Optional,
                caMgRatio: FieldStatus.Optional,
                fineness: FieldStatus.Optional,
            }
    }
}